import { createSlice } from '@reduxjs/toolkit';
import { getVersion } from 'react-native-device-info';
//
import { getAppVersions } from '~store/app/thunks';

const status = {
  versions: 'idle',
};
export const { actions, reducer } = createSlice({
  name: 'app',
  initialState: {
    versions: [],
    version: getVersion(),
    status,
  },
  reducers: {
    setStatus: (state, { payload: { key, value } }) => {
      state.status[key] = value;
    },
    resetStatus: (state) => {
      state.status = status;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAppVersions.pending, (state) => {
        state.status.versions = 'pending';
      })
      .addCase(getAppVersions.fulfilled, (state, { payload }) => {
        if (payload.success) {
          state.versions = payload.data;
        }
        state.status.versions = 'succeeded';
      });
  },
});

export default reducer;
